<script>
export default {
    methods : {
        validateStep1() {
            const data = this.SelectedData;
            const errors = [];
            if(!data.translateFrom.value) {
                errors.push('Translate From');
            }
            if(!data.translateTo.value) {
                errors.push('Translate To');
            }
            if(!data.turnaround.ID) {
                errors.push('Turnaround Speed');
            } else if(!data.turnaround.Available) {
                errors.push('Turnaround Speed');
            }
            if(!data.expertise) {
                errors.push('Expertise for Your Translation');
            }
            if(!data.fileUploaded) {
                errors.push('Upload Your Document');
            }
            if(!data.numberWords) {
                errors.push('Word Count');
            }
            if(data.expertise) {
                if(!data.namesPlaces && data.expertise == 'Certified') {
                    errors.push('Names and Places');
                }
            }
            if(!data.description) {
                errors.push('Please enter a description of the document you are uploading. The maximum amount of text allowed is 2,000 characters.');
            } else if(data.description.length > 2000 || data.description.length < 3) {
                errors.push('Please enter a description of the document you are uploading. The maximum amount of text allowed is 2,000 characters.');
            }

            if(this.accountData.CustomerType == 'guest') {
                if(!data.firstName) {
                    errors.push('First Name');
                }
                if(!data.lastName) {
                    errors.push('Last Name');
                }
                if(!this.validEmail(data.email)) {
                    errors.push('Email');
                }
            }
            //console.log(this.wordLimitMet);
            if(errors.length) {
                this.errors = errors;
                this.$refs.checkouttop.scrollIntoView({ behavior: "smooth", });
                return false;
            } else if(this.wordLimitMet) {
                this.errors = false;
                this.$refs.checkouttop.scrollIntoView({ behavior: "smooth", });
                return false;
            } else {
                this.errors = false;
                return true;
            }
        },
        validEmail(email) {
            const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        },
        checkWordLimit() {
            if(this.SelectedData.turnaround && !isNaN(this.SelectedData.numberWords)) {
                let WordLimit = parseInt(this.SelectedData.turnaround.WordLimit);
                if(this.SelectedData.expertise == 'Certified') {
                    WordLimit = parseInt(this.SelectedData.turnaround.wordLimitCertified); 
                } else if(this.CheckoutData.specialTurnarounds?.includes(this.SelectedData.turnaround.ID) || this.CheckoutData.inhouseTurnarounds?.includes(this.SelectedData.turnaround.ID)) {
                    WordLimit = parseInt(this.SelectedData.turnaround.wordLimitInhouse); 
                }
                if (this.SelectedData.numberWords > WordLimit) {
                    this.wordLimitMet = true;
                } else {
                    this.wordLimitMet = false;
                }
            }
            
        },
    }
}
</script>